import React from 'react';
import { NavLink } from 'react-router-dom';
import ConsoleShell from './ConsoleShell';

/**
 * A school's own console: the same shell as the admin console
 * (`ConsoleShell`) with a nav of its own. Wraps the /partners/dashboard screens, which
 * only a partner account reaches (`ProtectedRoute requirePartner`).
 */
const PartnerLayout: React.FC<{
  children: React.ReactNode;
  title?: string;
  subtitle?: React.ReactNode;
  actions?: React.ReactNode;
  wide?: boolean;
}> = ({ children, ...shell }) => {
  const nav = (
    <NavLink
      to="/partners/dashboard"
      end
      className={({ isActive }) => `sgk-admin__navlink${isActive ? ' is-active' : ''}`}
      data-testid="partner-nav-listing-link"
    >
      My listing
    </NavLink>
  );

  return (
    <ConsoleShell nav={nav} testIdPrefix="partner" orgLabel="Partner of" {...shell}>
      {children}
    </ConsoleShell>
  );
};

export default PartnerLayout;
